// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "deathknight.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UnitReference } from "./common";
import { ItemSwap } from "./common";
import { CustomRotation } from "./common";
/**
 * @generated from protobuf message proto.DeathknightTalents
 */
export interface DeathknightTalents {
    /**
     * Blood
     *
     * @generated from protobuf field: int32 butchery = 1;
     */
    butchery: number;
    /**
     * @generated from protobuf field: int32 subversion = 2;
     */
    subversion: number;
    /**
     * @generated from protobuf field: int32 blade_barrier = 3;
     */
    bladeBarrier: number;
    /**
     * @generated from protobuf field: int32 bladed_armor = 4;
     */
    bladedArmor: number;
    /**
     * @generated from protobuf field: int32 scent_of_blood = 5;
     */
    scentOfBlood: number;
    /**
     * @generated from protobuf field: int32 two_handed_weapon_specialization = 6;
     */
    twoHandedWeaponSpecialization: number;
    /**
     * @generated from protobuf field: bool rune_tap = 7;
     */
    runeTap: boolean;
    /**
     * @generated from protobuf field: int32 dark_conviction = 8;
     */
    darkConviction: number;
    /**
     * @generated from protobuf field: int32 death_rune_mastery = 9;
     */
    deathRuneMastery: number;
    /**
     * @generated from protobuf field: int32 improved_rune_tap = 10;
     */
    improvedRuneTap: number;
    /**
     * @generated from protobuf field: int32 spell_deflection = 11;
     */
    spellDeflection: number;
    /**
     * @generated from protobuf field: int32 vendetta = 12;
     */
    vendetta: number;
    /**
     * @generated from protobuf field: int32 bloody_strikes = 13;
     */
    bloodyStrikes: number;
    /**
     * @generated from protobuf field: int32 veteran_of_the_third_war = 14;
     */
    veteranOfTheThirdWar: number;
    /**
     * @generated from protobuf field: bool mark_of_blood = 15;
     */
    markOfBlood: boolean;
    /**
     * @generated from protobuf field: int32 bloody_vengeance = 16;
     */
    bloodyVengeance: number;
    /**
     * @generated from protobuf field: int32 abominations_might = 17;
     */
    abominationsMight: number;
    /**
     * @generated from protobuf field: int32 bloodworms = 18;
     */
    bloodworms: number;
    /**
     * @generated from protobuf field: bool hysteria = 19;
     */
    hysteria: boolean;
    /**
     * @generated from protobuf field: int32 improved_blood_presence = 20;
     */
    improvedBloodPresence: number;
    /**
     * @generated from protobuf field: int32 improved_death_strike = 21;
     */
    improvedDeathStrike: number;
    /**
     * @generated from protobuf field: int32 sudden_doom = 22;
     */
    suddenDoom: number;
    /**
     * @generated from protobuf field: bool vampiric_blood = 23;
     */
    vampiricBlood: boolean;
    /**
     * @generated from protobuf field: int32 will_of_the_necropolis = 24;
     */
    willOfTheNecropolis: number;
    /**
     * @generated from protobuf field: bool heart_strike = 25;
     */
    heartStrike: boolean;
    /**
     * @generated from protobuf field: int32 might_of_mograine = 26;
     */
    mightOfMograine: number;
    /**
     * @generated from protobuf field: int32 blood_gorged = 27;
     */
    bloodGorged: number;
    /**
     * @generated from protobuf field: bool dancing_rune_weapon = 28;
     */
    dancingRuneWeapon: boolean;
    /**
     * Frost
     *
     * @generated from protobuf field: int32 improved_icy_touch = 29;
     */
    improvedIcyTouch: number;
    /**
     * @generated from protobuf field: int32 runic_power_mastery = 30;
     */
    runicPowerMastery: number;
    /**
     * @generated from protobuf field: int32 toughness = 31;
     */
    toughness: number;
    /**
     * @generated from protobuf field: int32 icy_reach = 32;
     */
    icyReach: number;
    /**
     * @generated from protobuf field: int32 black_ice = 33;
     */
    blackIce: number;
    /**
     * @generated from protobuf field: int32 nerves_of_cold_steel = 34;
     */
    nervesOfColdSteel: number;
    /**
     * @generated from protobuf field: int32 icy_talons = 35;
     */
    icyTalons: number;
    /**
     * @generated from protobuf field: bool lichborne = 36;
     */
    lichborne: boolean;
    /**
     * @generated from protobuf field: int32 annihilation = 37;
     */
    annihilation: number;
    /**
     * @generated from protobuf field: int32 killing_machine = 38;
     */
    killingMachine: number;
    /**
     * @generated from protobuf field: int32 chill_of_the_grave = 39;
     */
    chillOfTheGrave: number;
    /**
     * @generated from protobuf field: int32 endless_winter = 40;
     */
    endlessWinter: number;
    /**
     * @generated from protobuf field: int32 frigid_dreadplate = 41;
     */
    frigidDreadplate: number;
    /**
     * @generated from protobuf field: int32 glacier_rot = 42;
     */
    glacierRot: number;
    /**
     * @generated from protobuf field: bool deathchill = 43;
     */
    deathchill: boolean;
    /**
     * @generated from protobuf field: bool improved_icy_talons = 44;
     */
    improvedIcyTalons: boolean;
    /**
     * @generated from protobuf field: int32 merciless_combat = 45;
     */
    mercilessCombat: number;
    /**
     * @generated from protobuf field: int32 rime = 46;
     */
    rime: number;
    /**
     * @generated from protobuf field: int32 chilblains = 47;
     */
    chilblains: number;
    /**
     * @generated from protobuf field: bool hungering_cold = 48;
     */
    hungeringCold: boolean;
    /**
     * @generated from protobuf field: int32 improved_frost_presence = 49;
     */
    improvedFrostPresence: number;
    /**
     * @generated from protobuf field: int32 threat_of_thassarian = 50;
     */
    threatOfThassarian: number;
    /**
     * @generated from protobuf field: int32 blood_of_the_north = 51;
     */
    bloodOfTheNorth: number;
    /**
     * @generated from protobuf field: bool unbreakable_armor = 52;
     */
    unbreakableArmor: boolean;
    /**
     * @generated from protobuf field: int32 acclimation = 53;
     */
    acclimation: number;
    /**
     * @generated from protobuf field: bool frost_strike = 54;
     */
    frostStrike: boolean;
    /**
     * @generated from protobuf field: int32 guile_of_gorefiend = 55;
     */
    guileOfGorefiend: number;
    /**
     * @generated from protobuf field: int32 tundra_stalker = 56;
     */
    tundraStalker: number;
    /**
     * @generated from protobuf field: bool howling_blast = 57;
     */
    howlingBlast: boolean;
    /**
     * Unholy
     *
     * @generated from protobuf field: int32 vicious_strikes = 58;
     */
    viciousStrikes: number;
    /**
     * @generated from protobuf field: int32 virulence = 59;
     */
    virulence: number;
    /**
     * @generated from protobuf field: int32 anticipation = 60;
     */
    anticipation: number;
    /**
     * @generated from protobuf field: int32 epidemic = 61;
     */
    epidemic: number;
    /**
     * @generated from protobuf field: int32 morbidity = 62;
     */
    morbidity: number;
    /**
     * @generated from protobuf field: int32 unholy_command = 63;
     */
    unholyCommand: number;
    /**
     * @generated from protobuf field: int32 ravenous_dead = 64;
     */
    ravenousDead: number;
    /**
     * @generated from protobuf field: int32 outbreak = 65;
     */
    outbreak: number;
    /**
     * @generated from protobuf field: int32 necrosis = 66;
     */
    necrosis: number;
    /**
     * @generated from protobuf field: bool corpse_explosion = 67;
     */
    corpseExplosion: boolean;
    /**
     * @generated from protobuf field: int32 on_a_pale_horse = 68;
     */
    onAPaleHorse: number;
    /**
     * @generated from protobuf field: int32 blood_caked_blade = 69;
     */
    bloodCakedBlade: number;
    /**
     * @generated from protobuf field: int32 night_of_the_dead = 70;
     */
    nightOfTheDead: number;
    /**
     * @generated from protobuf field: bool unholy_blight = 71;
     */
    unholyBlight: boolean;
    /**
     * @generated from protobuf field: int32 impurity = 72;
     */
    impurity: number;
    /**
     * @generated from protobuf field: int32 dirge = 73;
     */
    dirge: number;
    /**
     * @generated from protobuf field: int32 desecration = 74;
     */
    desecration: number;
    /**
     * @generated from protobuf field: int32 magic_suppression = 75;
     */
    magicSuppression: number;
    /**
     * @generated from protobuf field: int32 reaping = 76;
     */
    reaping: number;
    /**
     * @generated from protobuf field: bool master_of_ghouls = 77;
     */
    masterOfGhouls: boolean;
    /**
     * @generated from protobuf field: int32 desolation = 78;
     */
    desolation: number;
    /**
     * @generated from protobuf field: bool anti_magic_zone = 79;
     */
    antiMagicZone: boolean;
    /**
     * @generated from protobuf field: int32 improved_unholy_presence = 80;
     */
    improvedUnholyPresence: number;
    /**
     * @generated from protobuf field: bool ghoul_frenzy = 81;
     */
    ghoulFrenzy: boolean;
    /**
     * @generated from protobuf field: int32 crypt_fever = 82;
     */
    cryptFever: number;
    /**
     * @generated from protobuf field: bool bone_shield = 83;
     */
    boneShield: boolean;
    /**
     * @generated from protobuf field: int32 wandering_plague = 84;
     */
    wanderingPlague: number;
    /**
     * @generated from protobuf field: int32 ebon_plaguebringer = 85;
     */
    ebonPlaguebringer: number;
    /**
     * @generated from protobuf field: bool scourge_strike = 86;
     */
    scourgeStrike: boolean;
    /**
     * @generated from protobuf field: int32 rage_of_rivendare = 87;
     */
    rageOfRivendare: number;
    /**
     * @generated from protobuf field: bool summon_gargoyle = 88;
     */
    summonGargoyle: boolean;
}
/**
 * @generated from protobuf message proto.Deathknight
 */
export interface Deathknight {
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation rotation = 1;
     */
    rotation?: Deathknight_Rotation;
    /**
     * @generated from protobuf field: proto.Deathknight.Options options = 3;
     */
    options?: Deathknight_Options;
}
/**
 * @generated from protobuf message proto.Deathknight.Rotation
 */
export interface Deathknight_Rotation {
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.FrostRotationType frost_rotation_type = 19;
     */
    frostRotationType: Deathknight_Rotation_FrostRotationType;
    /**
     * @generated from protobuf field: proto.CustomRotation frost_custom_rotation = 20;
     */
    frostCustomRotation?: CustomRotation;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.ArmyOfTheDead army_of_the_dead = 1;
     */
    armyOfTheDead: Deathknight_Rotation_ArmyOfTheDead;
    /**
     * @generated from protobuf field: bool use_death_and_decay = 2;
     */
    useDeathAndDecay: boolean;
    /**
     * @generated from protobuf field: bool bt_ghoul_frenzy = 3;
     */
    btGhoulFrenzy: boolean;
    /**
     * @generated from protobuf field: double disease_refresh_duration = 4;
     */
    diseaseRefreshDuration: number;
    /**
     * @generated from protobuf field: bool refresh_horn_of_winter = 5;
     */
    refreshHornOfWinter: boolean;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.FirstDisease first_disease = 6;
     */
    firstDisease: Deathknight_Rotation_FirstDisease;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.DeathAndDecayPrio death_and_decay_prio = 7;
     */
    deathAndDecayPrio: Deathknight_Rotation_DeathAndDecayPrio;
    /**
     * @generated from protobuf field: bool use_empower_rune_weapon = 8;
     */
    useEmpowerRuneWeapon: boolean;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.BloodRuneFiller blood_rune_filler = 9;
     */
    bloodRuneFiller: Deathknight_Rotation_BloodRuneFiller;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.Presence starting_presence = 10;
     */
    startingPresence: Deathknight_Rotation_Presence;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.BloodTap blood_tap = 11;
     */
    bloodTap: Deathknight_Rotation_BloodTap;
    /**
     * @generated from protobuf field: bool use_ams = 13;
     */
    useAms: boolean;
    /**
     * @generated from protobuf field: double avg_ams_success_rate = 14;
     */
    avgAmsSuccessRate: number;
    /**
     * @generated from protobuf field: double avg_ams_hit = 15;
     */
    avgAmsHit: number;
    /**
     * @generated from protobuf field: bool auto_rotation = 16;
     */
    autoRotation: boolean;
    /**
     * @generated from protobuf field: bool desync_rotation = 17;
     */
    desyncRotation: boolean;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.Presence bl_presence = 18;
     */
    blPresence: Deathknight_Rotation_Presence;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.Presence presence = 21;
     */
    presence: Deathknight_Rotation_Presence;
    /**
     * @generated from protobuf field: bool hold_erw_army = 22;
     */
    holdErwArmy: boolean;
    /**
     * @generated from protobuf field: bool use_gargoyle = 23;
     */
    useGargoyle: boolean;
    /**
     * @generated from protobuf field: bool pre_nerfed_gargoyle = 24;
     */
    preNerfedGargoyle: boolean;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.Presence gargoyle_presence = 25;
     */
    gargoylePresence: Deathknight_Rotation_Presence;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.DrwDiseases drw_diseases = 26;
     */
    drwDiseases: Deathknight_Rotation_DrwDiseases;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.BloodOpener blood_opener = 27;
     */
    bloodOpener: Deathknight_Rotation_BloodOpener;
    /**
     * @generated from protobuf field: bool enable_weapon_swap = 28;
     */
    enableWeaponSwap: boolean;
    /**
     * @generated from protobuf field: proto.ItemSwap weapon_swap = 29;
     */
    weaponSwap?: ItemSwap;
    /**
     * @generated from protobuf field: bool use_dancing_rune_weapon = 30;
     */
    useDancingRuneWeapon: boolean;
    /**
     * @generated from protobuf field: proto.Deathknight.Rotation.BloodSpell blood_spender = 31;
     */
    bloodSpender: Deathknight_Rotation_BloodSpell;
    /**
     * @generated from protobuf field: double virulence_refresh = 32;
     */
    virulenceRefresh: number;
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.DrwDiseases
 */
export enum Deathknight_Rotation_DrwDiseases {
    /**
     * @generated from protobuf enum value: DoNotApply = 0;
     */
    DoNotApply = 0,
    /**
     * @generated from protobuf enum value: Normal = 1;
     */
    Normal = 1,
    /**
     * @generated from protobuf enum value: Pestilence = 2;
     */
    Pestilence = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.ArmyOfTheDead
 */
export enum Deathknight_Rotation_ArmyOfTheDead {
    /**
     * @generated from protobuf enum value: DoNotUse = 0;
     */
    DoNotUse = 0,
    /**
     * @generated from protobuf enum value: PreCast = 1;
     */
    PreCast = 1,
    /**
     * @generated from protobuf enum value: AsMajorCd = 2;
     */
    AsMajorCd = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.BloodTap
 */
export enum Deathknight_Rotation_BloodTap {
    /**
     * @generated from protobuf enum value: GhoulFrenzy = 0;
     */
    GhoulFrenzy = 0,
    /**
     * @generated from protobuf enum value: IcyTouch = 1;
     */
    IcyTouch = 1,
    /**
     * @generated from protobuf enum value: BloodStrikeBT = 2;
     */
    BloodStrikeBT = 2,
    /**
     * @generated from protobuf enum value: BloodBoilBT = 3;
     */
    BloodBoilBT = 3
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.DeathAndDecayPrio
 */
export enum Deathknight_Rotation_DeathAndDecayPrio {
    /**
     * @generated from protobuf enum value: MaxRuneDowntime = 0;
     */
    MaxRuneDowntime = 0,
    /**
     * @generated from protobuf enum value: MaxDndUptime = 1;
     */
    MaxDndUptime = 1
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.FirstDisease
 */
export enum Deathknight_Rotation_FirstDisease {
    /**
     * @generated from protobuf enum value: FrostFever = 0;
     */
    FrostFever = 0,
    /**
     * @generated from protobuf enum value: BloodPlague = 1;
     */
    BloodPlague = 1
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.BloodRuneFiller
 */
export enum Deathknight_Rotation_BloodRuneFiller {
    /**
     * @generated from protobuf enum value: BloodStrike = 0;
     */
    BloodStrike = 0,
    /**
     * @generated from protobuf enum value: BloodBoil = 1;
     */
    BloodBoil = 1
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.Presence
 */
export enum Deathknight_Rotation_Presence {
    /**
     * @generated from protobuf enum value: Blood = 0;
     */
    Blood = 0,
    /**
     * @generated from protobuf enum value: Unholy = 1;
     */
    Unholy = 1,
    /**
     * @generated from protobuf enum value: Frost = 2;
     */
    Frost = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.FrostRotationType
 */
export enum Deathknight_Rotation_FrostRotationType {
    /**
     * @generated from protobuf enum value: UnknownType = 0;
     */
    UnknownType = 0,
    /**
     * @generated from protobuf enum value: SingleTarget = 1;
     */
    SingleTarget = 1,
    /**
     * @generated from protobuf enum value: Custom = 2;
     */
    Custom = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.BloodOpener
 */
export enum Deathknight_Rotation_BloodOpener {
    /**
     * @generated from protobuf enum value: Standard = 0;
     */
    Standard = 0,
    /**
     * @generated from protobuf enum value: Experimental_1 = 1;
     */
    Experimental_1 = 1,
    /**
     * @generated from protobuf enum value: Experimental_2 = 2;
     */
    Experimental_2 = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.BloodSpell
 */
export enum Deathknight_Rotation_BloodSpell {
    /**
     * @generated from protobuf enum value: HS = 0;
     */
    HS = 0,
    /**
     * @generated from protobuf enum value: BB = 1;
     */
    BB = 1,
    /**
     * @generated from protobuf enum value: BS = 2;
     */
    BS = 2
}
/**
 * @generated from protobuf enum proto.Deathknight.Rotation.CustomSpellOption
 */
export enum Deathknight_Rotation_CustomSpellOption {
    /**
     * @generated from protobuf enum value: CustomNoSpell = 0;
     */
    CustomNoSpell = 0,
    /**
     * @generated from protobuf enum value: CustomIcyTouch = 1;
     */
    CustomIcyTouch = 1,
    /**
     * @generated from protobuf enum value: CustomPlagueStrike = 2;
     */
    CustomPlagueStrike = 2,
    /**
     * @generated from protobuf enum value: CustomPestilence = 3;
     */
    CustomPestilence = 3,
    /**
     * @generated from protobuf enum value: CustomObliterate = 4;
     */
    CustomObliterate = 4,
    /**
     * @generated from protobuf enum value: CustomHowlingBlast = 5;
     */
    CustomHowlingBlast = 5,
    /**
     * @generated from protobuf enum value: CustomHowlingBlastRime = 6;
     */
    CustomHowlingBlastRime = 6,
    /**
     * @generated from protobuf enum value: CustomBloodBoil = 7;
     */
    CustomBloodBoil = 7,
    /**
     * @generated from protobuf enum value: CustomBloodStrike = 8;
     */
    CustomBloodStrike = 8,
    /**
     * @generated from protobuf enum value: CustomDeathAndDecay = 9;
     */
    CustomDeathAndDecay = 9,
    /**
     * @generated from protobuf enum value: CustomHornOfWinter = 10;
     */
    CustomHornOfWinter = 10,
    /**
     * @generated from protobuf enum value: CustomUnbreakableArmor = 11;
     */
    CustomUnbreakableArmor = 11,
    /**
     * @generated from protobuf enum value: CustomBloodTap = 12;
     */
    CustomBloodTap = 12,
    /**
     * @generated from protobuf enum value: CustomEmpoweredRuneWeapon = 13;
     */
    CustomEmpoweredRuneWeapon = 13,
    /**
     * @generated from protobuf enum value: CustomFrostStrike = 14;
     */
    CustomFrostStrike = 14
}
/**
 * @generated from protobuf message proto.Deathknight.Options
 */
export interface Deathknight_Options {
    /**
     * @generated from protobuf field: double starting_runic_power = 1;
     */
    startingRunicPower: number;
    /**
     * @generated from protobuf field: double pet_uptime = 2;
     */
    petUptime: number;
    /**
     * @generated from protobuf field: bool precast_ghoul_frenzy = 3;
     */
    precastGhoulFrenzy: boolean;
    /**
     * @generated from protobuf field: bool precast_horn_of_winter = 4;
     */
    precastHornOfWinter: boolean;
    /**
     * @generated from protobuf field: proto.UnitReference unholy_frenzy_target = 5;
     */
    unholyFrenzyTarget?: UnitReference;
    /**
     * @generated from protobuf field: bool drw_pesti_apply = 6;
     */
    drwPestiApply: boolean;
    /**
     * @generated from protobuf field: bool new_drw = 7;
     */
    newDrw: boolean;
    /**
     * @generated from protobuf field: double disease_downtime = 8;
     */
    diseaseDowntime: number;
}
/**
 * @generated from protobuf message proto.TankDeathknight
 */
export interface TankDeathknight {
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation rotation = 1;
     */
    rotation?: TankDeathknight_Rotation;
    /**
     * @generated from protobuf field: proto.TankDeathknight.Options options = 3;
     */
    options?: TankDeathknight_Options;
}
/**
 * @generated from protobuf message proto.TankDeathknight.Rotation
 */
export interface TankDeathknight_Rotation {
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation.Opener opener = 1;
     */
    opener: TankDeathknight_Rotation_Opener;
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation.OptimizationSetting optimization_setting = 2;
     */
    optimizationSetting: TankDeathknight_Rotation_OptimizationSetting;
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation.BloodSpell blood_spell = 3;
     */
    bloodSpell: TankDeathknight_Rotation_BloodSpell;
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation.Presence presence = 4;
     */
    presence: TankDeathknight_Rotation_Presence;
    /**
     * @generated from protobuf field: proto.TankDeathknight.Rotation.BloodTapPrio blood_tap_prio = 5;
     */
    bloodTapPrio: TankDeathknight_Rotation_BloodTapPrio;
}
/**
 * @generated from protobuf enum proto.TankDeathknight.Rotation.Opener
 */
export enum TankDeathknight_Rotation_Opener {
    /**
     * @generated from protobuf enum value: Regular = 0;
     */
    Regular = 0,
    /**
     * @generated from protobuf enum value: Threat = 1;
     */
    Threat = 1
}
/**
 * @generated from protobuf enum proto.TankDeathknight.Rotation.OptimizationSetting
 */
export enum TankDeathknight_Rotation_OptimizationSetting {
    /**
     * @generated from protobuf enum value: Hps = 0;
     */
    Hps = 0,
    /**
     * @generated from protobuf enum value: Tps = 1;
     */
    Tps = 1
}
/**
 * @generated from protobuf enum proto.TankDeathknight.Rotation.BloodSpell
 */
export enum TankDeathknight_Rotation_BloodSpell {
    /**
     * @generated from protobuf enum value: BloodStrike = 0;
     */
    BloodStrike = 0,
    /**
     * @generated from protobuf enum value: BloodBoil = 1;
     */
    BloodBoil = 1,
    /**
     * @generated from protobuf enum value: HeartStrike = 2;
     */
    HeartStrike = 2
}
/**
 * @generated from protobuf enum proto.TankDeathknight.Rotation.BloodTapPrio
 */
export enum TankDeathknight_Rotation_BloodTapPrio {
    /**
     * @generated from protobuf enum value: Defensive = 0;
     */
    Defensive = 0,
    /**
     * @generated from protobuf enum value: Offensive = 1;
     */
    Offensive = 1
}
/**
 * @generated from protobuf enum proto.TankDeathknight.Rotation.Presence
 */
export enum TankDeathknight_Rotation_Presence {
    /**
     * @generated from protobuf enum value: Blood = 0;
     */
    Blood = 0,
    /**
     * @generated from protobuf enum value: Frost = 1;
     */
    Frost = 1,
    /**
     * @generated from protobuf enum value: Unholy = 2;
     */
    Unholy = 2
}
/**
 * @generated from protobuf message proto.TankDeathknight.Options
 */
export interface TankDeathknight_Options {
    /**
     * @generated from protobuf field: double starting_runic_power = 1;
     */
    startingRunicPower: number;
    /**
     * @generated from protobuf field: proto.UnitReference unholy_frenzy_target = 2;
     */
    unholyFrenzyTarget?: UnitReference;
    /**
     * @generated from protobuf field: double defensive_delay = 3;
     */
    defensiveDelay: number;
}
/**
 * @generated from protobuf enum proto.DeathknightMajorGlyph
 */
export enum DeathknightMajorGlyph {
    /**
     * @generated from protobuf enum value: DeathknightMajorGlyphNone = 0;
     */
    DeathknightMajorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfAntiMagicShell = 43533;
     */
    GlyphOfAntiMagicShell = 43533,
    /**
     * @generated from protobuf enum value: GlyphOfBloodStrike = 43826;
     */
    GlyphOfBloodStrike = 43826,
    /**
     * @generated from protobuf enum value: GlyphOfBoneShield = 43536;
     */
    GlyphOfBoneShield = 43536,
    /**
     * @generated from protobuf enum value: GlyphOfChainsOfIce = 43537;
     */
    GlyphOfChainsOfIce = 43537,
    /**
     * @generated from protobuf enum value: GlyphOfDancingRuneWeapon = 45799;
     */
    GlyphOfDancingRuneWeapon = 45799,
    /**
     * @generated from protobuf enum value: GlyphOfDarkCommand = 43538;
     */
    GlyphOfDarkCommand = 43538,
    /**
     * @generated from protobuf enum value: GlyphOfDarkDeath = 45804;
     */
    GlyphOfDarkDeath = 45804,
    /**
     * @generated from protobuf enum value: GlyphOfDeathAndDecay = 43542;
     */
    GlyphOfDeathAndDecay = 43542,
    /**
     * @generated from protobuf enum value: GlyphOfDeathGrip = 43541;
     */
    GlyphOfDeathGrip = 43541,
    /**
     * @generated from protobuf enum value: GlyphOfDeathStrike = 43827;
     */
    GlyphOfDeathStrike = 43827,
    /**
     * @generated from protobuf enum value: GlyphOfDisease = 45805;
     */
    GlyphOfDisease = 45805,
    /**
     * @generated from protobuf enum value: GlyphOfFrostStrike = 43543;
     */
    GlyphOfFrostStrike = 43543,
    /**
     * @generated from protobuf enum value: GlyphOfHeartStrike = 43534;
     */
    GlyphOfHeartStrike = 43534,
    /**
     * @generated from protobuf enum value: GlyphOfHowlingBlast = 45806;
     */
    GlyphOfHowlingBlast = 45806,
    /**
     * @generated from protobuf enum value: GlyphOfHungeringCold = 45800;
     */
    GlyphOfHungeringCold = 45800,
    /**
     * @generated from protobuf enum value: GlyphOfIceboundFortitude = 43545;
     */
    GlyphOfIceboundFortitude = 43545,
    /**
     * @generated from protobuf enum value: GlyphOfIcyTouch = 43546;
     */
    GlyphOfIcyTouch = 43546,
    /**
     * @generated from protobuf enum value: GlyphOfObliterate = 43547;
     */
    GlyphOfObliterate = 43547,
    /**
     * @generated from protobuf enum value: GlyphOfPlagueStrike = 43548;
     */
    GlyphOfPlagueStrike = 43548,
    /**
     * @generated from protobuf enum value: GlyphOfRuneStrike = 43550;
     */
    GlyphOfRuneStrike = 43550,
    /**
     * @generated from protobuf enum value: GlyphOfRuneTap = 43825;
     */
    GlyphOfRuneTap = 43825,
    /**
     * @generated from protobuf enum value: GlyphOfScourgeStrike = 43551;
     */
    GlyphOfScourgeStrike = 43551,
    /**
     * @generated from protobuf enum value: GlyphOfStrangulate = 43552;
     */
    GlyphOfStrangulate = 43552,
    /**
     * @generated from protobuf enum value: GlyphOfTheGhoul = 43549;
     */
    GlyphOfTheGhoul = 43549,
    /**
     * @generated from protobuf enum value: GlyphOfUnbreakableArmor = 43553;
     */
    GlyphOfUnbreakableArmor = 43553,
    /**
     * @generated from protobuf enum value: GlyphOfUnholyBlight = 45803;
     */
    GlyphOfUnholyBlight = 45803,
    /**
     * @generated from protobuf enum value: GlyphOfVampiricBlood = 43554;
     */
    GlyphOfVampiricBlood = 43554
}
/**
 * @generated from protobuf enum proto.DeathknightMinorGlyph
 */
export enum DeathknightMinorGlyph {
    /**
     * @generated from protobuf enum value: DeathknightMinorGlyphNone = 0;
     */
    DeathknightMinorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfBloodTap = 43535;
     */
    GlyphOfBloodTap = 43535,
    /**
     * @generated from protobuf enum value: GlyphOfCorpseExplosion = 43671;
     */
    GlyphOfCorpseExplosion = 43671,
    /**
     * @generated from protobuf enum value: GlyphOfDeathSEmbrace = 43539;
     */
    GlyphOfDeathSEmbrace = 43539,
    /**
     * @generated from protobuf enum value: GlyphOfHornOfWinter = 43544;
     */
    GlyphOfHornOfWinter = 43544,
    /**
     * @generated from protobuf enum value: GlyphOfPestilence = 43672;
     */
    GlyphOfPestilence = 43672,
    /**
     * @generated from protobuf enum value: GlyphOfRaiseDead = 43673;
     */
    GlyphOfRaiseDead = 43673
}
// @generated message type with reflection information, may provide speed optimized methods
class DeathknightTalents$Type extends MessageType<DeathknightTalents> {
    constructor() {
        super("proto.DeathknightTalents", [
            { no: 1, name: "butchery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subversion", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "blade_barrier", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "bladed_armor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "scent_of_blood", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "two_handed_weapon_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "rune_tap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "dark_conviction", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "death_rune_mastery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "improved_rune_tap", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "spell_deflection", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "vendetta", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "bloody_strikes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "veteran_of_the_third_war", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "mark_of_blood", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "bloody_vengeance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "abominations_might", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "bloodworms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "hysteria", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "improved_blood_presence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "improved_death_strike", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "sudden_doom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "vampiric_blood", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "will_of_the_necropolis", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "heart_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "might_of_mograine", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "blood_gorged", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "dancing_rune_weapon", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "improved_icy_touch", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "runic_power_mastery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "toughness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "icy_reach", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "black_ice", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "nerves_of_cold_steel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "icy_talons", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "lichborne", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "annihilation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "killing_machine", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 39, name: "chill_of_the_grave", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 40, name: "endless_winter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 41, name: "frigid_dreadplate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "glacier_rot", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 43, name: "deathchill", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 44, name: "improved_icy_talons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 45, name: "merciless_combat", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 46, name: "rime", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "chilblains", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 48, name: "hungering_cold", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 49, name: "improved_frost_presence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 50, name: "threat_of_thassarian", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 51, name: "blood_of_the_north", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 52, name: "unbreakable_armor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 53, name: "acclimation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "frost_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 55, name: "guile_of_gorefiend", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 56, name: "tundra_stalker", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 57, name: "howling_blast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 58, name: "vicious_strikes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 59, name: "virulence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "anticipation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 61, name: "epidemic", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 62, name: "morbidity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 63, name: "unholy_command", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 64, name: "ravenous_dead", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 65, name: "outbreak", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 66, name: "necrosis", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 67, name: "corpse_explosion", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 68, name: "on_a_pale_horse", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 69, name: "blood_caked_blade", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 70, name: "night_of_the_dead", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 71, name: "unholy_blight", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 72, name: "impurity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 73, name: "dirge", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 74, name: "desecration", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 75, name: "magic_suppression", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 76, name: "reaping", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 77, name: "master_of_ghouls", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 78, name: "desolation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 79, name: "anti_magic_zone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 80, name: "improved_unholy_presence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 81, name: "ghoul_frenzy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 82, name: "crypt_fever", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 83, name: "bone_shield", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 84, name: "wandering_plague", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 85, name: "ebon_plaguebringer", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 86, name: "scourge_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 87, name: "rage_of_rivendare", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 88, name: "summon_gargoyle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeathknightTalents>): DeathknightTalents {
        const message = { butchery: 0, subversion: 0, bladeBarrier: 0, bladedArmor: 0, scentOfBlood: 0, twoHandedWeaponSpecialization: 0, runeTap: false, darkConviction: 0, deathRuneMastery: 0, improvedRuneTap: 0, spellDeflection: 0, vendetta: 0, bloodyStrikes: 0, veteranOfTheThirdWar: 0, markOfBlood: false, bloodyVengeance: 0, abominationsMight: 0, bloodworms: 0, hysteria: false, improvedBloodPresence: 0, improvedDeathStrike: 0, suddenDoom: 0, vampiricBlood: false, willOfTheNecropolis: 0, heartStrike: false, mightOfMograine: 0, bloodGorged: 0, dancingRuneWeapon: false, improvedIcyTouch: 0, runicPowerMastery: 0, toughness: 0, icyReach: 0, blackIce: 0, nervesOfColdSteel: 0, icyTalons: 0, lichborne: false, annihilation: 0, killingMachine: 0, chillOfTheGrave: 0, endlessWinter: 0, frigidDreadplate: 0, glacierRot: 0, deathchill: false, improvedIcyTalons: false, mercilessCombat: 0, rime: 0, chilblains: 0, hungeringCold: false, improvedFrostPresence: 0, threatOfThassarian: 0, bloodOfTheNorth: 0, unbreakableArmor: false, acclimation: 0, frostStrike: false, guileOfGorefiend: 0, tundraStalker: 0, howlingBlast: false, viciousStrikes: 0, virulence: 0, anticipation: 0, epidemic: 0, morbidity: 0, unholyCommand: 0, ravenousDead: 0, outbreak: 0, necrosis: 0, corpseExplosion: false, onAPaleHorse: 0, bloodCakedBlade: 0, nightOfTheDead: 0, unholyBlight: false, impurity: 0, dirge: 0, desecration: 0, magicSuppression: 0, reaping: 0, masterOfGhouls: false, desolation: 0, antiMagicZone: false, improvedUnholyPresence: 0, ghoulFrenzy: false, cryptFever: 0, boneShield: false, wanderingPlague: 0, ebonPlaguebringer: 0, scourgeStrike: false, rageOfRivendare: 0, summonGargoyle: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeathknightTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeathknightTalents): DeathknightTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 butchery */ 1:
                    message.butchery = reader.int32();
                    break;
                case /* int32 subversion */ 2:
                    message.subversion = reader.int32();
                    break;
                case /* int32 blade_barrier */ 3:
                    message.bladeBarrier = reader.int32();
                    break;
                case /* int32 bladed_armor */ 4:
                    message.bladedArmor = reader.int32();
                    break;
                case /* int32 scent_of_blood */ 5:
                    message.scentOfBlood = reader.int32();
                    break;
                case /* int32 two_handed_weapon_specialization */ 6:
                    message.twoHandedWeaponSpecialization = reader.int32();
                    break;
                case /* bool rune_tap */ 7:
                    message.runeTap = reader.bool();
                    break;
                case /* int32 dark_conviction */ 8:
                    message.darkConviction = reader.int32();
                    break;
                case /* int32 death_rune_mastery */ 9:
                    message.deathRuneMastery = reader.int32();
                    break;
                case /* int32 improved_rune_tap */ 10:
                    message.improvedRuneTap = reader.int32();
                    break;
                case /* int32 spell_deflection */ 11:
                    message.spellDeflection = reader.int32();
                    break;
                case /* int32 vendetta */ 12:
                    message.vendetta = reader.int32();
                    break;
                case /* int32 bloody_strikes */ 13:
                    message.bloodyStrikes = reader.int32();
                    break;
                case /* int32 veteran_of_the_third_war */ 14:
                    message.veteranOfTheThirdWar = reader.int32();
                    break;
                case /* bool mark_of_blood */ 15:
                    message.markOfBlood = reader.bool();
                    break;
                case /* int32 bloody_vengeance */ 16:
                    message.bloodyVengeance = reader.int32();
                    break;
                case /* int32 abominations_might */ 17:
                    message.abominationsMight = reader.int32();
                    break;
                case /* int32 bloodworms */ 18:
                    message.bloodworms = reader.int32();
                    break;
                case /* bool hysteria */ 19:
                    message.hysteria = reader.bool();
                    break;
                case /* int32 improved_blood_presence */ 20:
                    message.improvedBloodPresence = reader.int32();
                    break;
                case /* int32 improved_death_strike */ 21:
                    message.improvedDeathStrike = reader.int32();
                    break;
                case /* int32 sudden_doom */ 22:
                    message.suddenDoom = reader.int32();
                    break;
                case /* bool vampiric_blood */ 23:
                    message.vampiricBlood = reader.bool();
                    break;
                case /* int32 will_of_the_necropolis */ 24:
                    message.willOfTheNecropolis = reader.int32();
                    break;
                case /* bool heart_strike */ 25:
                    message.heartStrike = reader.bool();
                    break;
                case /* int32 might_of_mograine */ 26:
                    message.mightOfMograine = reader.int32();
                    break;
                case /* int32 blood_gorged */ 27:
                    message.bloodGorged = reader.int32();
                    break;
                case /* bool dancing_rune_weapon */ 28:
                    message.dancingRuneWeapon = reader.bool();
                    break;
                case /* int32 improved_icy_touch */ 29:
                    message.improvedIcyTouch = reader.int32();
                    break;
                case /* int32 runic_power_mastery */ 30:
                    message.runicPowerMastery = reader.int32();
                    break;
                case /* int32 toughness */ 31:
                    message.toughness = reader.int32();
                    break;
                case /* int32 icy_reach */ 32:
                    message.icyReach = reader.int32();
                    break;
                case /* int32 black_ice */ 33:
                    message.blackIce = reader.int32();
                    break;
                case /* int32 nerves_of_cold_steel */ 34:
                    message.nervesOfColdSteel = reader.int32();
                    break;
                case /* int32 icy_talons */ 35:
                    message.icyTalons = reader.int32();
                    break;
                case /* bool lichborne */ 36:
                    message.lichborne = reader.bool();
                    break;
                case /* int32 annihilation */ 37:
                    message.annihilation = reader.int32();
                    break;
                case /* int32 killing_machine */ 38:
                    message.killingMachine = reader.int32();
                    break;
                case /* int32 chill_of_the_grave */ 39:
                    message.chillOfTheGrave = reader.int32();
                    break;
                case /* int32 endless_winter */ 40:
                    message.endlessWinter = reader.int32();
                    break;
                case /* int32 frigid_dreadplate */ 41:
                    message.frigidDreadplate = reader.int32();
                    break;
                case /* int32 glacier_rot */ 42:
                    message.glacierRot = reader.int32();
                    break;
                case /* bool deathchill */ 43:
                    message.deathchill = reader.bool();
                    break;
                case /* bool improved_icy_talons */ 44:
                    message.improvedIcyTalons = reader.bool();
                    break;
                case /* int32 merciless_combat */ 45:
                    message.mercilessCombat = reader.int32();
                    break;
                case /* int32 rime */ 46:
                    message.rime = reader.int32();
                    break;
                case /* int32 chilblains */ 47:
                    message.chilblains = reader.int32();
                    break;
                case /* bool hungering_cold */ 48:
                    message.hungeringCold = reader.bool();
                    break;
                case /* int32 improved_frost_presence */ 49:
                    message.improvedFrostPresence = reader.int32();
                    break;
                case /* int32 threat_of_thassarian */ 50:
                    message.threatOfThassarian = reader.int32();
                    break;
                case /* int32 blood_of_the_north */ 51:
                    message.bloodOfTheNorth = reader.int32();
                    break;
                case /* bool unbreakable_armor */ 52:
                    message.unbreakableArmor = reader.bool();
                    break;
                case /* int32 acclimation */ 53:
                    message.acclimation = reader.int32();
                    break;
                case /* bool frost_strike */ 54:
                    message.frostStrike = reader.bool();
                    break;
                case /* int32 guile_of_gorefiend */ 55:
                    message.guileOfGorefiend = reader.int32();
                    break;
                case /* int32 tundra_stalker */ 56:
                    message.tundraStalker = reader.int32();
                    break;
                case /* bool howling_blast */ 57:
                    message.howlingBlast = reader.bool();
                    break;
                case /* int32 vicious_strikes */ 58:
                    message.viciousStrikes = reader.int32();
                    break;
                case /* int32 virulence */ 59:
                    message.virulence = reader.int32();
                    break;
                case /* int32 anticipation */ 60:
                    message.anticipation = reader.int32();
                    break;
                case /* int32 epidemic */ 61:
                    message.epidemic = reader.int32();
                    break;
                case /* int32 morbidity */ 62:
                    message.morbidity = reader.int32();
                    break;
                case /* int32 unholy_command */ 63:
                    message.unholyCommand = reader.int32();
                    break;
                case /* int32 ravenous_dead */ 64:
                    message.ravenousDead = reader.int32();
                    break;
                case /* int32 outbreak */ 65:
                    message.outbreak = reader.int32();
                    break;
                case /* int32 necrosis */ 66:
                    message.necrosis = reader.int32();
                    break;
                case /* bool corpse_explosion */ 67:
                    message.corpseExplosion = reader.bool();
                    break;
                case /* int32 on_a_pale_horse */ 68:
                    message.onAPaleHorse = reader.int32();
                    break;
                case /* int32 blood_caked_blade */ 69:
                    message.bloodCakedBlade = reader.int32();
                    break;
                case /* int32 night_of_the_dead */ 70:
                    message.nightOfTheDead = reader.int32();
                    break;
                case /* bool unholy_blight */ 71:
                    message.unholyBlight = reader.bool();
                    break;
                case /* int32 impurity */ 72:
                    message.impurity = reader.int32();
                    break;
                case /* int32 dirge */ 73:
                    message.dirge = reader.int32();
                    break;
                case /* int32 desecration */ 74:
                    message.desecration = reader.int32();
                    break;
                case /* int32 magic_suppression */ 75:
                    message.magicSuppression = reader.int32();
                    break;
                case /* int32 reaping */ 76:
                    message.reaping = reader.int32();
                    break;
                case /* bool master_of_ghouls */ 77:
                    message.masterOfGhouls = reader.bool();
                    break;
                case /* int32 desolation */ 78:
                    message.desolation = reader.int32();
                    break;
                case /* bool anti_magic_zone */ 79:
                    message.antiMagicZone = reader.bool();
                    break;
                case /* int32 improved_unholy_presence */ 80:
                    message.improvedUnholyPresence = reader.int32();
                    break;
                case /* bool ghoul_frenzy */ 81:
                    message.ghoulFrenzy = reader.bool();
                    break;
                case /* int32 crypt_fever */ 82:
                    message.cryptFever = reader.int32();
                    break;
                case /* bool bone_shield */ 83:
                    message.boneShield = reader.bool();
                    break;
                case /* int32 wandering_plague */ 84:
                    message.wanderingPlague = reader.int32();
                    break;
                case /* int32 ebon_plaguebringer */ 85:
                    message.ebonPlaguebringer = reader.int32();
                    break;
                case /* bool scourge_strike */ 86:
                    message.scourgeStrike = reader.bool();
                    break;
                case /* int32 rage_of_rivendare */ 87:
                    message.rageOfRivendare = reader.int32();
                    break;
                case /* bool summon_gargoyle */ 88:
                    message.summonGargoyle = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeathknightTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 butchery = 1; */
        if (message.butchery !== 0)
            writer.tag(1, WireType.Varint).int32(message.butchery);
        /* int32 subversion = 2; */
        if (message.subversion !== 0)
            writer.tag(2, WireType.Varint).int32(message.subversion);
        /* int32 blade_barrier = 3; */
        if (message.bladeBarrier !== 0)
            writer.tag(3, WireType.Varint).int32(message.bladeBarrier);
        /* int32 bladed_armor = 4; */
        if (message.bladedArmor !== 0)
            writer.tag(4, WireType.Varint).int32(message.bladedArmor);
        /* int32 scent_of_blood = 5; */
        if (message.scentOfBlood !== 0)
            writer.tag(5, WireType.Varint).int32(message.scentOfBlood);
        /* int32 two_handed_weapon_specialization = 6; */
        if (message.twoHandedWeaponSpecialization !== 0)
            writer.tag(6, WireType.Varint).int32(message.twoHandedWeaponSpecialization);
        /* bool rune_tap = 7; */
        if (message.runeTap !== false)
            writer.tag(7, WireType.Varint).bool(message.runeTap);
        /* int32 dark_conviction = 8; */
        if (message.darkConviction !== 0)
            writer.tag(8, WireType.Varint).int32(message.darkConviction);
        /* int32 death_rune_mastery = 9; */
        if (message.deathRuneMastery !== 0)
            writer.tag(9, WireType.Varint).int32(message.deathRuneMastery);
        /* int32 improved_rune_tap = 10; */
        if (message.improvedRuneTap !== 0)
            writer.tag(10, WireType.Varint).int32(message.improvedRuneTap);
        /* int32 spell_deflection = 11; */
        if (message.spellDeflection !== 0)
            writer.tag(11, WireType.Varint).int32(message.spellDeflection);
        /* int32 vendetta = 12; */
        if (message.vendetta !== 0)
            writer.tag(12, WireType.Varint).int32(message.vendetta);
        /* int32 bloody_strikes = 13; */
        if (message.bloodyStrikes !== 0)
            writer.tag(13, WireType.Varint).int32(message.bloodyStrikes);
        /* int32 veteran_of_the_third_war = 14; */
        if (message.veteranOfTheThirdWar !== 0)
            writer.tag(14, WireType.Varint).int32(message.veteranOfTheThirdWar);
        /* bool mark_of_blood = 15; */
        if (message.markOfBlood !== false)
            writer.tag(15, WireType.Varint).bool(message.markOfBlood);
        /* int32 bloody_vengeance = 16; */
        if (message.bloodyVengeance !== 0)
            writer.tag(16, WireType.Varint).int32(message.bloodyVengeance);
        /* int32 abominations_might = 17; */
        if (message.abominationsMight !== 0)
            writer.tag(17, WireType.Varint).int32(message.abominationsMight);
        /* int32 bloodworms = 18; */
        if (message.bloodworms !== 0)
            writer.tag(18, WireType.Varint).int32(message.bloodworms);
        /* bool hysteria = 19; */
        if (message.hysteria !== false)
            writer.tag(19, WireType.Varint).bool(message.hysteria);
        /* int32 improved_blood_presence = 20; */
        if (message.improvedBloodPresence !== 0)
            writer.tag(20, WireType.Varint).int32(message.improvedBloodPresence);
        /* int32 improved_death_strike = 21; */
        if (message.improvedDeathStrike !== 0)
            writer.tag(21, WireType.Varint).int32(message.improvedDeathStrike);
        /* int32 sudden_doom = 22; */
        if (message.suddenDoom !== 0)
            writer.tag(22, WireType.Varint).int32(message.suddenDoom);
        /* bool vampiric_blood = 23; */
        if (message.vampiricBlood !== false)
            writer.tag(23, WireType.Varint).bool(message.vampiricBlood);
        /* int32 will_of_the_necropolis = 24; */
        if (message.willOfTheNecropolis !== 0)
            writer.tag(24, WireType.Varint).int32(message.willOfTheNecropolis);
        /* bool heart_strike = 25; */
        if (message.heartStrike !== false)
            writer.tag(25, WireType.Varint).bool(message.heartStrike);
        /* int32 might_of_mograine = 26; */
        if (message.mightOfMograine !== 0)
            writer.tag(26, WireType.Varint).int32(message.mightOfMograine);
        /* int32 blood_gorged = 27; */
        if (message.bloodGorged !== 0)
            writer.tag(27, WireType.Varint).int32(message.bloodGorged);
        /* bool dancing_rune_weapon = 28; */
        if (message.dancingRuneWeapon !== false)
            writer.tag(28, WireType.Varint).bool(message.dancingRuneWeapon);
        /* int32 improved_icy_touch = 29; */
        if (message.improvedIcyTouch !== 0)
            writer.tag(29, WireType.Varint).int32(message.improvedIcyTouch);
        /* int32 runic_power_mastery = 30; */
        if (message.runicPowerMastery !== 0)
            writer.tag(30, WireType.Varint).int32(message.runicPowerMastery);
        /* int32 toughness = 31; */
        if (message.toughness !== 0)
            writer.tag(31, WireType.Varint).int32(message.toughness);
        /* int32 icy_reach = 32; */
        if (message.icyReach !== 0)
            writer.tag(32, WireType.Varint).int32(message.icyReach);
        /* int32 black_ice = 33; */
        if (message.blackIce !== 0)
            writer.tag(33, WireType.Varint).int32(message.blackIce);
        /* int32 nerves_of_cold_steel = 34; */
        if (message.nervesOfColdSteel !== 0)
            writer.tag(34, WireType.Varint).int32(message.nervesOfColdSteel);
        /* int32 icy_talons = 35; */
        if (message.icyTalons !== 0)
            writer.tag(35, WireType.Varint).int32(message.icyTalons);
        /* bool lichborne = 36; */
        if (message.lichborne !== false)
            writer.tag(36, WireType.Varint).bool(message.lichborne);
        /* int32 annihilation = 37; */
        if (message.annihilation !== 0)
            writer.tag(37, WireType.Varint).int32(message.annihilation);
        /* int32 killing_machine = 38; */
        if (message.killingMachine !== 0)
            writer.tag(38, WireType.Varint).int32(message.killingMachine);
        /* int32 chill_of_the_grave = 39; */
        if (message.chillOfTheGrave !== 0)
            writer.tag(39, WireType.Varint).int32(message.chillOfTheGrave);
        /* int32 endless_winter = 40; */
        if (message.endlessWinter !== 0)
            writer.tag(40, WireType.Varint).int32(message.endlessWinter);
        /* int32 frigid_dreadplate = 41; */
        if (message.frigidDreadplate !== 0)
            writer.tag(41, WireType.Varint).int32(message.frigidDreadplate);
        /* int32 glacier_rot = 42; */
        if (message.glacierRot !== 0)
            writer.tag(42, WireType.Varint).int32(message.glacierRot);
        /* bool deathchill = 43; */
        if (message.deathchill !== false)
            writer.tag(43, WireType.Varint).bool(message.deathchill);
        /* bool improved_icy_talons = 44; */
        if (message.improvedIcyTalons !== false)
            writer.tag(44, WireType.Varint).bool(message.improvedIcyTalons);
        /* int32 merciless_combat = 45; */
        if (message.mercilessCombat !== 0)
            writer.tag(45, WireType.Varint).int32(message.mercilessCombat);
        /* int32 rime = 46; */
        if (message.rime !== 0)
            writer.tag(46, WireType.Varint).int32(message.rime);
        /* int32 chilblains = 47; */
        if (message.chilblains !== 0)
            writer.tag(47, WireType.Varint).int32(message.chilblains);
        /* bool hungering_cold = 48; */
        if (message.hungeringCold !== false)
            writer.tag(48, WireType.Varint).bool(message.hungeringCold);
        /* int32 improved_frost_presence = 49; */
        if (message.improvedFrostPresence !== 0)
            writer.tag(49, WireType.Varint).int32(message.improvedFrostPresence);
        /* int32 threat_of_thassarian = 50; */
        if (message.threatOfThassarian !== 0)
            writer.tag(50, WireType.Varint).int32(message.threatOfThassarian);
        /* int32 blood_of_the_north = 51; */
        if (message.bloodOfTheNorth !== 0)
            writer.tag(51, WireType.Varint).int32(message.bloodOfTheNorth);
        /* bool unbreakable_armor = 52; */
        if (message.unbreakableArmor !== false)
            writer.tag(52, WireType.Varint).bool(message.unbreakableArmor);
        /* int32 acclimation = 53; */
        if (message.acclimation !== 0)
            writer.tag(53, WireType.Varint).int32(message.acclimation);
        /* bool frost_strike = 54; */
        if (message.frostStrike !== false)
            writer.tag(54, WireType.Varint).bool(message.frostStrike);
        /* int32 guile_of_gorefiend = 55; */
        if (message.guileOfGorefiend !== 0)
            writer.tag(55, WireType.Varint).int32(message.guileOfGorefiend);
        /* int32 tundra_stalker = 56; */
        if (message.tundraStalker !== 0)
            writer.tag(56, WireType.Varint).int32(message.tundraStalker);
        /* bool howling_blast = 57; */
        if (message.howlingBlast !== false)
            writer.tag(57, WireType.Varint).bool(message.howlingBlast);
        /* int32 vicious_strikes = 58; */
        if (message.viciousStrikes !== 0)
            writer.tag(58, WireType.Varint).int32(message.viciousStrikes);
        /* int32 virulence = 59; */
        if (message.virulence !== 0)
            writer.tag(59, WireType.Varint).int32(message.virulence);
        /* int32 anticipation = 60; */
        if (message.anticipation !== 0)
            writer.tag(60, WireType.Varint).int32(message.anticipation);
        /* int32 epidemic = 61; */
        if (message.epidemic !== 0)
            writer.tag(61, WireType.Varint).int32(message.epidemic);
        /* int32 morbidity = 62; */
        if (message.morbidity !== 0)
            writer.tag(62, WireType.Varint).int32(message.morbidity);
        /* int32 unholy_command = 63; */
        if (message.unholyCommand !== 0)
            writer.tag(63, WireType.Varint).int32(message.unholyCommand);
        /* int32 ravenous_dead = 64; */
        if (message.ravenousDead !== 0)
            writer.tag(64, WireType.Varint).int32(message.ravenousDead);
        /* int32 outbreak = 65; */
        if (message.outbreak !== 0)
            writer.tag(65, WireType.Varint).int32(message.outbreak);
        /* int32 necrosis = 66; */
        if (message.necrosis !== 0)
            writer.tag(66, WireType.Varint).int32(message.necrosis);
        /* bool corpse_explosion = 67; */
        if (message.corpseExplosion !== false)
            writer.tag(67, WireType.Varint).bool(message.corpseExplosion);
        /* int32 on_a_pale_horse = 68; */
        if (message.onAPaleHorse !== 0)
            writer.tag(68, WireType.Varint).int32(message.onAPaleHorse);
        /* int32 blood_caked_blade = 69; */
        if (message.bloodCakedBlade !== 0)
            writer.tag(69, WireType.Varint).int32(message.bloodCakedBlade);
        /* int32 night_of_the_dead = 70; */
        if (message.nightOfTheDead !== 0)
            writer.tag(70, WireType.Varint).int32(message.nightOfTheDead);
        /* bool unholy_blight = 71; */
        if (message.unholyBlight !== false)
            writer.tag(71, WireType.Varint).bool(message.unholyBlight);
        /* int32 impurity = 72; */
        if (message.impurity !== 0)
            writer.tag(72, WireType.Varint).int32(message.impurity);
        /* int32 dirge = 73; */
        if (message.dirge !== 0)
            writer.tag(73, WireType.Varint).int32(message.dirge);
        /* int32 desecration = 74; */
        if (message.desecration !== 0)
            writer.tag(74, WireType.Varint).int32(message.desecration);
        /* int32 magic_suppression = 75; */
        if (message.magicSuppression !== 0)
            writer.tag(75, WireType.Varint).int32(message.magicSuppression);
        /* int32 reaping = 76; */
        if (message.reaping !== 0)
            writer.tag(76, WireType.Varint).int32(message.reaping);
        /* bool master_of_ghouls = 77; */
        if (message.masterOfGhouls !== false)
            writer.tag(77, WireType.Varint).bool(message.masterOfGhouls);
        /* int32 desolation = 78; */
        if (message.desolation !== 0)
            writer.tag(78, WireType.Varint).int32(message.desolation);
        /* bool anti_magic_zone = 79; */
        if (message.antiMagicZone !== false)
            writer.tag(79, WireType.Varint).bool(message.antiMagicZone);
        /* int32 improved_unholy_presence = 80; */
        if (message.improvedUnholyPresence !== 0)
            writer.tag(80, WireType.Varint).int32(message.improvedUnholyPresence);
        /* bool ghoul_frenzy = 81; */
        if (message.ghoulFrenzy !== false)
            writer.tag(81, WireType.Varint).bool(message.ghoulFrenzy);
        /* int32 crypt_fever = 82; */
        if (message.cryptFever !== 0)
            writer.tag(82, WireType.Varint).int32(message.cryptFever);
        /* bool bone_shield = 83; */
        if (message.boneShield !== false)
            writer.tag(83, WireType.Varint).bool(message.boneShield);
        /* int32 wandering_plague = 84; */
        if (message.wanderingPlague !== 0)
            writer.tag(84, WireType.Varint).int32(message.wanderingPlague);
        /* int32 ebon_plaguebringer = 85; */
        if (message.ebonPlaguebringer !== 0)
            writer.tag(85, WireType.Varint).int32(message.ebonPlaguebringer);
        /* bool scourge_strike = 86; */
        if (message.scourgeStrike !== false)
            writer.tag(86, WireType.Varint).bool(message.scourgeStrike);
        /* int32 rage_of_rivendare = 87; */
        if (message.rageOfRivendare !== 0)
            writer.tag(87, WireType.Varint).int32(message.rageOfRivendare);
        /* bool summon_gargoyle = 88; */
        if (message.summonGargoyle !== false)
            writer.tag(88, WireType.Varint).bool(message.summonGargoyle);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DeathknightTalents
 */
export const DeathknightTalents = new DeathknightTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Deathknight$Type extends MessageType<Deathknight> {
    constructor() {
        super("proto.Deathknight", [
            { no: 1, name: "rotation", kind: "message", T: () => Deathknight_Rotation },
            { no: 3, name: "options", kind: "message", T: () => Deathknight_Options }
        ]);
    }
    create(value?: PartialMessage<Deathknight>): Deathknight {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Deathknight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Deathknight): Deathknight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Deathknight.Rotation rotation */ 1:
                    message.rotation = Deathknight_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.Deathknight.Options options */ 3:
                    message.options = Deathknight_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Deathknight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Deathknight.Rotation rotation = 1; */
        if (message.rotation)
            Deathknight_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Deathknight.Options options = 3; */
        if (message.options)
            Deathknight_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Deathknight
 */
export const Deathknight = new Deathknight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Deathknight_Rotation$Type extends MessageType<Deathknight_Rotation> {
    constructor() {
        super("proto.Deathknight.Rotation", [
            { no: 19, name: "frost_rotation_type", kind: "enum", T: () => ["proto.Deathknight.Rotation.FrostRotationType", Deathknight_Rotation_FrostRotationType] },
            { no: 20, name: "frost_custom_rotation", kind: "message", T: () => CustomRotation },
            { no: 1, name: "army_of_the_dead", kind: "enum", T: () => ["proto.Deathknight.Rotation.ArmyOfTheDead", Deathknight_Rotation_ArmyOfTheDead] },
            { no: 2, name: "use_death_and_decay", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "bt_ghoul_frenzy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "disease_refresh_duration", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "refresh_horn_of_winter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "first_disease", kind: "enum", T: () => ["proto.Deathknight.Rotation.FirstDisease", Deathknight_Rotation_FirstDisease] },
            { no: 7, name: "death_and_decay_prio", kind: "enum", T: () => ["proto.Deathknight.Rotation.DeathAndDecayPrio", Deathknight_Rotation_DeathAndDecayPrio] },
            { no: 8, name: "use_empower_rune_weapon", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "blood_rune_filler", kind: "enum", T: () => ["proto.Deathknight.Rotation.BloodRuneFiller", Deathknight_Rotation_BloodRuneFiller] },
            { no: 10, name: "starting_presence", kind: "enum", T: () => ["proto.Deathknight.Rotation.Presence", Deathknight_Rotation_Presence] },
            { no: 11, name: "blood_tap", kind: "enum", T: () => ["proto.Deathknight.Rotation.BloodTap", Deathknight_Rotation_BloodTap] },
            { no: 13, name: "use_ams", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "avg_ams_success_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "avg_ams_hit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "auto_rotation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "desync_rotation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "bl_presence", kind: "enum", T: () => ["proto.Deathknight.Rotation.Presence", Deathknight_Rotation_Presence] },
            { no: 21, name: "presence", kind: "enum", T: () => ["proto.Deathknight.Rotation.Presence", Deathknight_Rotation_Presence] },
            { no: 22, name: "hold_erw_army", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "use_gargoyle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "pre_nerfed_gargoyle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "gargoyle_presence", kind: "enum", T: () => ["proto.Deathknight.Rotation.Presence", Deathknight_Rotation_Presence] },
            { no: 26, name: "drw_diseases", kind: "enum", T: () => ["proto.Deathknight.Rotation.DrwDiseases", Deathknight_Rotation_DrwDiseases] },
            { no: 27, name: "blood_opener", kind: "enum", T: () => ["proto.Deathknight.Rotation.BloodOpener", Deathknight_Rotation_BloodOpener] },
            { no: 28, name: "enable_weapon_swap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "weapon_swap", kind: "message", T: () => ItemSwap },
            { no: 30, name: "use_dancing_rune_weapon", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "blood_spender", kind: "enum", T: () => ["proto.Deathknight.Rotation.BloodSpell", Deathknight_Rotation_BloodSpell] },
            { no: 32, name: "virulence_refresh", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Deathknight_Rotation>): Deathknight_Rotation {
        const message = { frostRotationType: 0, armyOfTheDead: 0, useDeathAndDecay: false, btGhoulFrenzy: false, diseaseRefreshDuration: 0, refreshHornOfWinter: false, firstDisease: 0, deathAndDecayPrio: 0, useEmpowerRuneWeapon: false, bloodRuneFiller: 0, startingPresence: 0, bloodTap: 0, useAms: false, avgAmsSuccessRate: 0, avgAmsHit: 0, autoRotation: false, desyncRotation: false, blPresence: 0, presence: 0, holdErwArmy: false, useGargoyle: false, preNerfedGargoyle: false, gargoylePresence: 0, drwDiseases: 0, bloodOpener: 0, enableWeaponSwap: false, useDancingRuneWeapon: false, bloodSpender: 0, virulenceRefresh: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Deathknight_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Deathknight_Rotation): Deathknight_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Deathknight.Rotation.FrostRotationType frost_rotation_type */ 19:
                    message.frostRotationType = reader.int32();
                    break;
                case /* proto.CustomRotation frost_custom_rotation */ 20:
                    message.frostCustomRotation = CustomRotation.internalBinaryRead(reader, reader.uint32(), options, message.frostCustomRotation);
                    break;
                case /* proto.Deathknight.Rotation.ArmyOfTheDead army_of_the_dead */ 1:
                    message.armyOfTheDead = reader.int32();
                    break;
                case /* bool use_death_and_decay */ 2:
                    message.useDeathAndDecay = reader.bool();
                    break;
                case /* bool bt_ghoul_frenzy */ 3:
                    message.btGhoulFrenzy = reader.bool();
                    break;
                case /* double disease_refresh_duration */ 4:
                    message.diseaseRefreshDuration = reader.double();
                    break;
                case /* bool refresh_horn_of_winter */ 5:
                    message.refreshHornOfWinter = reader.bool();
                    break;
                case /* proto.Deathknight.Rotation.FirstDisease first_disease */ 6:
                    message.firstDisease = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.DeathAndDecayPrio death_and_decay_prio */ 7:
                    message.deathAndDecayPrio = reader.int32();
                    break;
                case /* bool use_empower_rune_weapon */ 8:
                    message.useEmpowerRuneWeapon = reader.bool();
                    break;
                case /* proto.Deathknight.Rotation.BloodRuneFiller blood_rune_filler */ 9:
                    message.bloodRuneFiller = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.Presence starting_presence */ 10:
                    message.startingPresence = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.BloodTap blood_tap */ 11:
                    message.bloodTap = reader.int32();
                    break;
                case /* bool use_ams */ 13:
                    message.useAms = reader.bool();
                    break;
                case /* double avg_ams_success_rate */ 14:
                    message.avgAmsSuccessRate = reader.double();
                    break;
                case /* double avg_ams_hit */ 15:
                    message.avgAmsHit = reader.double();
                    break;
                case /* bool auto_rotation */ 16:
                    message.autoRotation = reader.bool();
                    break;
                case /* bool desync_rotation */ 17:
                    message.desyncRotation = reader.bool();
                    break;
                case /* proto.Deathknight.Rotation.Presence bl_presence */ 18:
                    message.blPresence = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.Presence presence */ 21:
                    message.presence = reader.int32();
                    break;
                case /* bool hold_erw_army */ 22:
                    message.holdErwArmy = reader.bool();
                    break;
                case /* bool use_gargoyle */ 23:
                    message.useGargoyle = reader.bool();
                    break;
                case /* bool pre_nerfed_gargoyle */ 24:
                    message.preNerfedGargoyle = reader.bool();
                    break;
                case /* proto.Deathknight.Rotation.Presence gargoyle_presence */ 25:
                    message.gargoylePresence = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.DrwDiseases drw_diseases */ 26:
                    message.drwDiseases = reader.int32();
                    break;
                case /* proto.Deathknight.Rotation.BloodOpener blood_opener */ 27:
                    message.bloodOpener = reader.int32();
                    break;
                case /* bool enable_weapon_swap */ 28:
                    message.enableWeaponSwap = reader.bool();
                    break;
                case /* proto.ItemSwap weapon_swap */ 29:
                    message.weaponSwap = ItemSwap.internalBinaryRead(reader, reader.uint32(), options, message.weaponSwap);
                    break;
                case /* bool use_dancing_rune_weapon */ 30:
                    message.useDancingRuneWeapon = reader.bool();
                    break;
                case /* proto.Deathknight.Rotation.BloodSpell blood_spender */ 31:
                    message.bloodSpender = reader.int32();
                    break;
                case /* double virulence_refresh */ 32:
                    message.virulenceRefresh = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Deathknight_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Deathknight.Rotation.FrostRotationType frost_rotation_type = 19; */
        if (message.frostRotationType !== 0)
            writer.tag(19, WireType.Varint).int32(message.frostRotationType);
        /* proto.CustomRotation frost_custom_rotation = 20; */
        if (message.frostCustomRotation)
            CustomRotation.internalBinaryWrite(message.frostCustomRotation, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* proto.Deathknight.Rotation.ArmyOfTheDead army_of_the_dead = 1; */
        if (message.armyOfTheDead !== 0)
            writer.tag(1, WireType.Varint).int32(message.armyOfTheDead);
        /* bool use_death_and_decay = 2; */
        if (message.useDeathAndDecay !== false)
            writer.tag(2, WireType.Varint).bool(message.useDeathAndDecay);
        /* bool bt_ghoul_frenzy = 3; */
        if (message.btGhoulFrenzy !== false)
            writer.tag(3, WireType.Varint).bool(message.btGhoulFrenzy);
        /* double disease_refresh_duration = 4; */
        if (message.diseaseRefreshDuration !== 0)
            writer.tag(4, WireType.Bit64).double(message.diseaseRefreshDuration);
        /* bool refresh_horn_of_winter = 5; */
        if (message.refreshHornOfWinter !== false)
            writer.tag(5, WireType.Varint).bool(message.refreshHornOfWinter);
        /* proto.Deathknight.Rotation.FirstDisease first_disease = 6; */
        if (message.firstDisease !== 0)
            writer.tag(6, WireType.Varint).int32(message.firstDisease);
        /* proto.Deathknight.Rotation.DeathAndDecayPrio death_and_decay_prio = 7; */
        if (message.deathAndDecayPrio !== 0)
            writer.tag(7, WireType.Varint).int32(message.deathAndDecayPrio);
        /* bool use_empower_rune_weapon = 8; */
        if (message.useEmpowerRuneWeapon !== false)
            writer.tag(8, WireType.Varint).bool(message.useEmpowerRuneWeapon);
        /* proto.Deathknight.Rotation.BloodRuneFiller blood_rune_filler = 9; */
        if (message.bloodRuneFiller !== 0)
            writer.tag(9, WireType.Varint).int32(message.bloodRuneFiller);
        /* proto.Deathknight.Rotation.Presence starting_presence = 10; */
        if (message.startingPresence !== 0)
            writer.tag(10, WireType.Varint).int32(message.startingPresence);
        /* proto.Deathknight.Rotation.BloodTap blood_tap = 11; */
        if (message.bloodTap !== 0)
            writer.tag(11, WireType.Varint).int32(message.bloodTap);
        /* bool use_ams = 13; */
        if (message.useAms !== false)
            writer.tag(13, WireType.Varint).bool(message.useAms);
        /* double avg_ams_success_rate = 14; */
        if (message.avgAmsSuccessRate !== 0)
            writer.tag(14, WireType.Bit64).double(message.avgAmsSuccessRate);
        /* double avg_ams_hit = 15; */
        if (message.avgAmsHit !== 0)
            writer.tag(15, WireType.Bit64).double(message.avgAmsHit);
        /* bool auto_rotation = 16; */
        if (message.autoRotation !== false)
            writer.tag(16, WireType.Varint).bool(message.autoRotation);
        /* bool desync_rotation = 17; */
        if (message.desyncRotation !== false)
            writer.tag(17, WireType.Varint).bool(message.desyncRotation);
        /* proto.Deathknight.Rotation.Presence bl_presence = 18; */
        if (message.blPresence !== 0)
            writer.tag(18, WireType.Varint).int32(message.blPresence);
        /* proto.Deathknight.Rotation.Presence presence = 21; */
        if (message.presence !== 0)
            writer.tag(21, WireType.Varint).int32(message.presence);
        /* bool hold_erw_army = 22; */
        if (message.holdErwArmy !== false)
            writer.tag(22, WireType.Varint).bool(message.holdErwArmy);
        /* bool use_gargoyle = 23; */
        if (message.useGargoyle !== false)
            writer.tag(23, WireType.Varint).bool(message.useGargoyle);
        /* bool pre_nerfed_gargoyle = 24; */
        if (message.preNerfedGargoyle !== false)
            writer.tag(24, WireType.Varint).bool(message.preNerfedGargoyle);
        /* proto.Deathknight.Rotation.Presence gargoyle_presence = 25; */
        if (message.gargoylePresence !== 0)
            writer.tag(25, WireType.Varint).int32(message.gargoylePresence);
        /* proto.Deathknight.Rotation.DrwDiseases drw_diseases = 26; */
        if (message.drwDiseases !== 0)
            writer.tag(26, WireType.Varint).int32(message.drwDiseases);
        /* proto.Deathknight.Rotation.BloodOpener blood_opener = 27; */
        if (message.bloodOpener !== 0)
            writer.tag(27, WireType.Varint).int32(message.bloodOpener);
        /* bool enable_weapon_swap = 28; */
        if (message.enableWeaponSwap !== false)
            writer.tag(28, WireType.Varint).bool(message.enableWeaponSwap);
        /* proto.ItemSwap weapon_swap = 29; */
        if (message.weaponSwap)
            ItemSwap.internalBinaryWrite(message.weaponSwap, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* bool use_dancing_rune_weapon = 30; */
        if (message.useDancingRuneWeapon !== false)
            writer.tag(30, WireType.Varint).bool(message.useDancingRuneWeapon);
        /* proto.Deathknight.Rotation.BloodSpell blood_spender = 31; */
        if (message.bloodSpender !== 0)
            writer.tag(31, WireType.Varint).int32(message.bloodSpender);
        /* double virulence_refresh = 32; */
        if (message.virulenceRefresh !== 0)
            writer.tag(32, WireType.Bit64).double(message.virulenceRefresh);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Deathknight.Rotation
 */
export const Deathknight_Rotation = new Deathknight_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Deathknight_Options$Type extends MessageType<Deathknight_Options> {
    constructor() {
        super("proto.Deathknight.Options", [
            { no: 1, name: "starting_runic_power", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "pet_uptime", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "precast_ghoul_frenzy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "precast_horn_of_winter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "unholy_frenzy_target", kind: "message", T: () => UnitReference },
            { no: 6, name: "drw_pesti_apply", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "new_drw", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "disease_downtime", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Deathknight_Options>): Deathknight_Options {
        const message = { startingRunicPower: 0, petUptime: 0, precastGhoulFrenzy: false, precastHornOfWinter: false, drwPestiApply: false, newDrw: false, diseaseDowntime: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Deathknight_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Deathknight_Options): Deathknight_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double starting_runic_power */ 1:
                    message.startingRunicPower = reader.double();
                    break;
                case /* double pet_uptime */ 2:
                    message.petUptime = reader.double();
                    break;
                case /* bool precast_ghoul_frenzy */ 3:
                    message.precastGhoulFrenzy = reader.bool();
                    break;
                case /* bool precast_horn_of_winter */ 4:
                    message.precastHornOfWinter = reader.bool();
                    break;
                case /* proto.UnitReference unholy_frenzy_target */ 5:
                    message.unholyFrenzyTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.unholyFrenzyTarget);
                    break;
                case /* bool drw_pesti_apply */ 6:
                    message.drwPestiApply = reader.bool();
                    break;
                case /* bool new_drw */ 7:
                    message.newDrw = reader.bool();
                    break;
                case /* double disease_downtime */ 8:
                    message.diseaseDowntime = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Deathknight_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double starting_runic_power = 1; */
        if (message.startingRunicPower !== 0)
            writer.tag(1, WireType.Bit64).double(message.startingRunicPower);
        /* double pet_uptime = 2; */
        if (message.petUptime !== 0)
            writer.tag(2, WireType.Bit64).double(message.petUptime);
        /* bool precast_ghoul_frenzy = 3; */
        if (message.precastGhoulFrenzy !== false)
            writer.tag(3, WireType.Varint).bool(message.precastGhoulFrenzy);
        /* bool precast_horn_of_winter = 4; */
        if (message.precastHornOfWinter !== false)
            writer.tag(4, WireType.Varint).bool(message.precastHornOfWinter);
        /* proto.UnitReference unholy_frenzy_target = 5; */
        if (message.unholyFrenzyTarget)
            UnitReference.internalBinaryWrite(message.unholyFrenzyTarget, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool drw_pesti_apply = 6; */
        if (message.drwPestiApply !== false)
            writer.tag(6, WireType.Varint).bool(message.drwPestiApply);
        /* bool new_drw = 7; */
        if (message.newDrw !== false)
            writer.tag(7, WireType.Varint).bool(message.newDrw);
        /* double disease_downtime = 8; */
        if (message.diseaseDowntime !== 0)
            writer.tag(8, WireType.Bit64).double(message.diseaseDowntime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Deathknight.Options
 */
export const Deathknight_Options = new Deathknight_Options$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TankDeathknight$Type extends MessageType<TankDeathknight> {
    constructor() {
        super("proto.TankDeathknight", [
            { no: 1, name: "rotation", kind: "message", T: () => TankDeathknight_Rotation },
            { no: 3, name: "options", kind: "message", T: () => TankDeathknight_Options }
        ]);
    }
    create(value?: PartialMessage<TankDeathknight>): TankDeathknight {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TankDeathknight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TankDeathknight): TankDeathknight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.TankDeathknight.Rotation rotation */ 1:
                    message.rotation = TankDeathknight_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.TankDeathknight.Options options */ 3:
                    message.options = TankDeathknight_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TankDeathknight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.TankDeathknight.Rotation rotation = 1; */
        if (message.rotation)
            TankDeathknight_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.TankDeathknight.Options options = 3; */
        if (message.options)
            TankDeathknight_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TankDeathknight
 */
export const TankDeathknight = new TankDeathknight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TankDeathknight_Rotation$Type extends MessageType<TankDeathknight_Rotation> {
    constructor() {
        super("proto.TankDeathknight.Rotation", [
            { no: 1, name: "opener", kind: "enum", T: () => ["proto.TankDeathknight.Rotation.Opener", TankDeathknight_Rotation_Opener] },
            { no: 2, name: "optimization_setting", kind: "enum", T: () => ["proto.TankDeathknight.Rotation.OptimizationSetting", TankDeathknight_Rotation_OptimizationSetting] },
            { no: 3, name: "blood_spell", kind: "enum", T: () => ["proto.TankDeathknight.Rotation.BloodSpell", TankDeathknight_Rotation_BloodSpell] },
            { no: 4, name: "presence", kind: "enum", T: () => ["proto.TankDeathknight.Rotation.Presence", TankDeathknight_Rotation_Presence] },
            { no: 5, name: "blood_tap_prio", kind: "enum", T: () => ["proto.TankDeathknight.Rotation.BloodTapPrio", TankDeathknight_Rotation_BloodTapPrio] }
        ]);
    }
    create(value?: PartialMessage<TankDeathknight_Rotation>): TankDeathknight_Rotation {
        const message = { opener: 0, optimizationSetting: 0, bloodSpell: 0, presence: 0, bloodTapPrio: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TankDeathknight_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TankDeathknight_Rotation): TankDeathknight_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.TankDeathknight.Rotation.Opener opener */ 1:
                    message.opener = reader.int32();
                    break;
                case /* proto.TankDeathknight.Rotation.OptimizationSetting optimization_setting */ 2:
                    message.optimizationSetting = reader.int32();
                    break;
                case /* proto.TankDeathknight.Rotation.BloodSpell blood_spell */ 3:
                    message.bloodSpell = reader.int32();
                    break;
                case /* proto.TankDeathknight.Rotation.Presence presence */ 4:
                    message.presence = reader.int32();
                    break;
                case /* proto.TankDeathknight.Rotation.BloodTapPrio blood_tap_prio */ 5:
                    message.bloodTapPrio = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TankDeathknight_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.TankDeathknight.Rotation.Opener opener = 1; */
        if (message.opener !== 0)
            writer.tag(1, WireType.Varint).int32(message.opener);
        /* proto.TankDeathknight.Rotation.OptimizationSetting optimization_setting = 2; */
        if (message.optimizationSetting !== 0)
            writer.tag(2, WireType.Varint).int32(message.optimizationSetting);
        /* proto.TankDeathknight.Rotation.BloodSpell blood_spell = 3; */
        if (message.bloodSpell !== 0)
            writer.tag(3, WireType.Varint).int32(message.bloodSpell);
        /* proto.TankDeathknight.Rotation.Presence presence = 4; */
        if (message.presence !== 0)
            writer.tag(4, WireType.Varint).int32(message.presence);
        /* proto.TankDeathknight.Rotation.BloodTapPrio blood_tap_prio = 5; */
        if (message.bloodTapPrio !== 0)
            writer.tag(5, WireType.Varint).int32(message.bloodTapPrio);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TankDeathknight.Rotation
 */
export const TankDeathknight_Rotation = new TankDeathknight_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TankDeathknight_Options$Type extends MessageType<TankDeathknight_Options> {
    constructor() {
        super("proto.TankDeathknight.Options", [
            { no: 1, name: "starting_runic_power", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "unholy_frenzy_target", kind: "message", T: () => UnitReference },
            { no: 3, name: "defensive_delay", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<TankDeathknight_Options>): TankDeathknight_Options {
        const message = { startingRunicPower: 0, defensiveDelay: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TankDeathknight_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TankDeathknight_Options): TankDeathknight_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double starting_runic_power */ 1:
                    message.startingRunicPower = reader.double();
                    break;
                case /* proto.UnitReference unholy_frenzy_target */ 2:
                    message.unholyFrenzyTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.unholyFrenzyTarget);
                    break;
                case /* double defensive_delay */ 3:
                    message.defensiveDelay = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TankDeathknight_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double starting_runic_power = 1; */
        if (message.startingRunicPower !== 0)
            writer.tag(1, WireType.Bit64).double(message.startingRunicPower);
        /* proto.UnitReference unholy_frenzy_target = 2; */
        if (message.unholyFrenzyTarget)
            UnitReference.internalBinaryWrite(message.unholyFrenzyTarget, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* double defensive_delay = 3; */
        if (message.defensiveDelay !== 0)
            writer.tag(3, WireType.Bit64).double(message.defensiveDelay);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TankDeathknight.Options
 */
export const TankDeathknight_Options = new TankDeathknight_Options$Type();
